import { facebookLandingRoutes } from 'site-modules/brand-landing/routes/facebook-landing';
import { oemShowroomRoutes } from 'site-modules/brand-landing/routes/oem-showroom';
import { partnerCarInsuranceLandingRoutes } from 'site-modules/brand-landing/routes/partner-car-insurance-landing';

export const routes = Array.prototype.concat(
  facebookLandingRoutes,
  oemShowroomRoutes,
  partnerCarInsuranceLandingRoutes
);
